import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  en: {
    // Navigation
    home: "Home",
    menu: "Menu",
    admin: "Admin Panel",
    login: "Login",
    logout: "Logout",
    language: "العربية",
    
    // Hero
    heroTitle: "Aljabr Laundry",
    heroSubtitle: "Premium laundry & pressing services",
    heroDescription: "Professional care for your garments with guaranteed quality",
    browseMenu: "Browse Our Menu",
    
    // Menu
    ourServices: "Our Services",
    categories: "Categories",
    subcategories: "Subcategories",
    allCategories: "All Categories",
    products: "Products",
    items: "items",
    viewAll: "View All",
    noProducts: "No products found",
    noCategories: "No categories found",
    noSubcategories: "No subcategories found",
    searchPlaceholder: "Search products...",
    searchFor: "Search for",
    filterByService: "Filter by service",
    allServices: "All Services",
    
    // Product - Pricing
    laundryPrice: "Regular Wash",
    dryCleanPrice: "Dry Clean",
    pressingPrice: "Pressing",
    regularWash: "Regular Wash",
    dryClean: "Dry Clean",
    pressing: "Pressing",
    priceIncVat: "incl. 15% VAT",
    sar: "SAR",
    serviceTypes: "Service Types",
    
    // Admin
    dashboard: "Dashboard",
    manageCategories: "Categories",
    manageSubcategories: "Subcategories",
    manageProducts: "Products",
    manageUsers: "Users",
    addCategory: "Add Category",
    editCategory: "Edit Category",
    deleteCategory: "Delete Category",
    addSubcategory: "Add Subcategory",
    editSubcategory: "Edit Subcategory",
    deleteSubcategory: "Delete Subcategory",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    deleteProduct: "Delete Product",
    addUser: "Add User",
    
    // Form fields
    nameEn: "Name (English)",
    nameAr: "Name (Arabic)",
    image: "Image",
    icon: "Icon",
    uploadImage: "Upload Image",
    changeImage: "Change Image",
    sortOrder: "Sort Order",
    active: "Active",
    inactive: "Inactive",
    status: "Status",
    category: "Category",
    subcategory: "Subcategory",
    selectCategory: "Select Category",
    selectSubcategory: "Select Subcategory",
    laundryPriceLabel: "Regular Wash Price (SAR)",
    dryCleanPriceLabel: "Dry Clean Price (SAR)",
    pressingPriceLabel: "Pressing Price (SAR)",
    
    // Price Lists
    priceLists: "Price Lists",
    priceList: "Price List",
    managePriceLists: "Create and manage multiple price lists",
    addPriceList: "Add Price List",
    editPriceList: "Edit Price List",
    duplicatePriceList: "Duplicate Price List",
    duplicateDescription: "Create a copy with all categories and products",
    duplicate: "Duplicate",
    noPriceLists: "No price lists yet",
    createFirst: "Create your first price list",
    default: "Default",
    selectPriceList: "Select Price List",
    allPriceLists: "All Price Lists",
    descriptionEn: "Description (English)",
    descriptionAr: "Description (Arabic)",
    
    // Auth
    email: "Email",
    password: "Password",
    name: "Name",
    role: "Role",
    adminRole: "Admin",
    editorRole: "Editor",
    loginTitle: "Admin Login",
    loginSubtitle: "Sign in to manage your menu",
    signIn: "Sign In",
    
    // Actions
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    confirm: "Confirm",
    close: "Close",
    actions: "Actions",
    
    // Stats
    totalCategories: "Total Categories",
    totalSubcategories: "Total Subcategories",
    totalProducts: "Total Products",
    activeProducts: "Active Products",
    totalUsers: "Total Users",
    
    // Messages
    deleteConfirm: "Are you sure? This action cannot be undone.",
    savedSuccess: "Saved successfully",
    deletedSuccess: "Deleted successfully",
    errorOccurred: "An error occurred",
    
    // Footer
    footerText: "Aljabr Laundry - Premium Laundry Services",
    allRightsReserved: "All rights reserved",
    
    backToMenu: "Back to Menu",
    backToCategory: "Back to Category",
    back: "Back",
    notFound: "Not Found",
    priceListNotFound: "The price list you're looking for doesn't exist.",
    
    // Price List Selection
    selectPriceListDesc: "Choose your service type to view our prices",
    choosePriceList: "Choose Your Price List",
    selectServiceType: "Select the service category that suits your needs",
    viewPrices: "View Prices",
    recommended: "Recommended",
  },
  ar: {
    // Navigation
    home: "الرئيسية",
    menu: "القائمة",
    admin: "لوحة التحكم",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    language: "English",
    
    // Hero
    heroTitle: "مغسلة الجبر",
    heroSubtitle: "خدمات غسيل وكي متميزة",
    heroDescription: "عناية احترافية بملابسك مع ضمان الجودة",
    browseMenu: "تصفح قائمتنا",
    
    // Menu
    ourServices: "خدماتنا",
    categories: "الأقسام",
    subcategories: "الأقسام الفرعية",
    allCategories: "جميع الأقسام",
    products: "المنتجات",
    items: "منتجات",
    viewAll: "عرض الكل",
    noProducts: "لا توجد منتجات",
    noCategories: "لا توجد أقسام",
    noSubcategories: "لا توجد أقسام فرعية",
    searchPlaceholder: "ابحث عن المنتجات...",
    searchFor: "البحث عن",
    filterByService: "تصفية حسب الخدمة",
    allServices: "جميع الخدمات",
    
    // Product - Pricing
    laundryPrice: "غسيل عادي",
    dryCleanPrice: "تنظيف جاف",
    pressingPrice: "كي",
    regularWash: "غسيل عادي",
    dryClean: "تنظيف جاف",
    pressing: "كي",
    priceIncVat: "شامل 15% ضريبة",
    sar: "ر.س",
    serviceTypes: "أنواع الخدمة",
    
    // Admin
    dashboard: "لوحة المعلومات",
    manageCategories: "الأقسام",
    manageSubcategories: "الأقسام الفرعية",
    manageProducts: "المنتجات",
    manageUsers: "المستخدمين",
    addCategory: "إضافة قسم",
    editCategory: "تعديل القسم",
    deleteCategory: "حذف القسم",
    addSubcategory: "إضافة قسم فرعي",
    editSubcategory: "تعديل القسم الفرعي",
    deleteSubcategory: "حذف القسم الفرعي",
    addProduct: "إضافة منتج",
    editProduct: "تعديل المنتج",
    deleteProduct: "حذف المنتج",
    addUser: "إضافة مستخدم",
    
    // Price Lists
    priceLists: "قوائم الأسعار",
    priceList: "قائمة الأسعار",
    managePriceLists: "إنشاء وإدارة قوائم أسعار متعددة",
    addPriceList: "إضافة قائمة أسعار",
    editPriceList: "تعديل قائمة الأسعار",
    duplicatePriceList: "نسخ قائمة الأسعار",
    duplicateDescription: "إنشاء نسخة مع جميع الأقسام والمنتجات",
    duplicate: "نسخ",
    noPriceLists: "لا توجد قوائم أسعار بعد",
    createFirst: "أنشئ قائمة الأسعار الأولى",
    default: "افتراضي",
    selectPriceList: "اختر قائمة الأسعار",
    allPriceLists: "جميع قوائم الأسعار",
    descriptionEn: "الوصف (إنجليزي)",
    descriptionAr: "الوصف (عربي)",
    
    // Form fields
    nameEn: "الاسم (إنجليزي)",
    nameAr: "الاسم (عربي)",
    image: "الصورة",
    icon: "الأيقونة",
    uploadImage: "رفع صورة",
    changeImage: "تغيير الصورة",
    sortOrder: "ترتيب العرض",
    active: "نشط",
    inactive: "غير نشط",
    status: "الحالة",
    category: "القسم",
    subcategory: "القسم الفرعي",
    selectCategory: "اختر القسم",
    selectSubcategory: "اختر القسم الفرعي",
    laundryPriceLabel: "سعر الغسيل العادي (ر.س)",
    dryCleanPriceLabel: "سعر التنظيف الجاف (ر.س)",
    pressingPriceLabel: "سعر الكي (ر.س)",
    
    // Auth
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    role: "الدور",
    adminRole: "مدير",
    editorRole: "محرر",
    loginTitle: "تسجيل دخول المدير",
    loginSubtitle: "سجل الدخول لإدارة القائمة",
    signIn: "تسجيل الدخول",
    
    // Actions
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    confirm: "تأكيد",
    close: "إغلاق",
    actions: "الإجراءات",
    
    // Stats
    totalCategories: "إجمالي الأقسام",
    totalSubcategories: "إجمالي الأقسام الفرعية",
    totalProducts: "إجمالي المنتجات",
    activeProducts: "المنتجات النشطة",
    totalUsers: "إجمالي المستخدمين",
    
    // Messages
    deleteConfirm: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
    savedSuccess: "تم الحفظ بنجاح",
    deletedSuccess: "تم الحذف بنجاح",
    errorOccurred: "حدث خطأ",
    
    // Footer
    footerText: "مغسلة الجبر - خدمات غسيل متميزة",
    allRightsReserved: "جميع الحقوق محفوظة",
    
    backToMenu: "العودة للقائمة",
    backToCategory: "العودة للقسم",
    back: "رجوع",
    notFound: "غير موجود",
    priceListNotFound: "قائمة الأسعار التي تبحث عنها غير موجودة.",
    
    // Price List Selection
    selectPriceListDesc: "اختر نوع الخدمة لعرض أسعارنا",
    choosePriceList: "اختر قائمة الأسعار",
    selectServiceType: "اختر فئة الخدمة التي تناسب احتياجاتك",
    viewPrices: "عرض الأسعار",
    recommended: "موصى به",
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('aljabr-lang') || 'en';
  });

  const toggleLanguage = useCallback(() => {
    setLang(prev => {
      const next = prev === 'en' ? 'ar' : 'en';
      localStorage.setItem('aljabr-lang', next);
      document.documentElement.dir = next === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = next;
      return next;
    });
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['en']?.[key] || key;
  }, [lang]);

  const isRTL = lang === 'ar';

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}
